<template>
  <div class="profile-settings-view">
    <Loader v-if="!state.isReady" :is-processing="true" />
    <ProfileSettings
      v-if="state.isReady"
      :user="user"
      :user-role="userRole"
      :active-appoinment-module-options="activeAppoinmentModuleOptions"
      :is-active-appoinment-module="isActiveAppoinmentModule"
      :is-active-auto-check-in-module="isActiveAutoCheckInModule"
      :is-active-kiosk-module="isActiveKioskModule"
    ></ProfileSettings>
  </div>
</template>

<script>
import { reactive, computed, onMounted } from "vue"
import { useStore } from "vuex"
import ProfileSettings from "@/v3views/UserSettings/ProfileSettings.vue"
import Loader from "@/v3components/shared/Loader/Loader.vue"

export default {
  name: "UserSettings",
  components: {
    ProfileSettings,
    Loader
  },
  setup() {
    const store = useStore()
    const state = reactive({
      isReady: false
    })

    const user = computed(() => store.getters["authentication/user"])

    const userRole = computed(() => store.getters["authentication/getUserRole"])

    const isActiveAppoinmentModule = computed(
      () => store.getters["schools/isActiveAppoinmentModule"]
    )

    const isActiveAutoCheckInModule = computed(
      () => store.getters["schools/isActiveAutoCheckInModule"]
    )

    const isActiveKioskModule = computed(
      () => store.getters["schools/isActiveKioskModule"]
    )

    const activeAppoinmentModuleOptions = computed(
      () => store.getters["schools/activeAppoinmentModuleOptions"]
    )

    onMounted(() => {
      store.dispatch("authentication/getUserSettings").finally(() => {
        state.isReady = true
      })
    })

    return {
      state,
      user,
      userRole,
      isActiveAppoinmentModule,
      isActiveAutoCheckInModule,
      isActiveKioskModule,
      activeAppoinmentModuleOptions
    }
  }
}
</script>
